// Firebase initialization — public client config (this is meant to be public)
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCzEJByX54SOeKeGUnPvmQfOEW1zakuwPM",
  authDomain: "vinly-ce987.firebaseapp.com",
  projectId: "vinly-ce987",
  storageBucket: "vinly-ce987.firebasestorage.app",
  messagingSenderId: "963871159878",
  appId: "1:963871159878:web:1e7991a3a646b00e0c3c47",
  measurementId: "G-KLMT9ZTJV8",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Use long-polling auto-detection to avoid WebChannel ReadableStream errors
// behind corporate / preview proxies (Emergent preview, Cloudflare, etc.).
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
